export interface DashboardFilterUISettingsInterface {
  label: string;
  description?: string;
  tooltip?: string;
  showInFilterComponent?: boolean;
  showWhenDisabled?: boolean;
  renderAtChildFilterComponent?: boolean;
  showLabel?: boolean;
  width?: string // css width in px, ex: '200px',
}

export class DashboardFilterUISettings {
  label: string;
  description?: string;
  tooltip?: string;
  showInFilterComponent?: boolean;
  showWhenDisabled?: boolean;
  renderAtChildFilterComponent?: boolean;
  showLabel?: boolean;
  width?: string;

  constructor(args: DashboardFilterUISettingsInterface) {
    this.label = args.label;
    this.description = args.description;
    this.tooltip = args.tooltip;
    this.showInFilterComponent = args.showInFilterComponent;
    this.showWhenDisabled = args.showWhenDisabled;
    this.renderAtChildFilterComponent = args.renderAtChildFilterComponent;
    this.showLabel = args.showLabel;
    this.width = args.width;
  }
}
